<template>
<a-row :gutter="24" class="new-row">
      <a-col :md="collapsed?0: 5" :sm="24" class="new-col">
    <a-card :bordered="false" class="new-tree-card">
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择') }}：<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div style="display: flex;margin-top: 10px;">
            <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
            <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
          </div>
          <!-- 树-->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    defaultExpandParent
                    @expand="onExpand">
                      <template slot="title" slot-scope="{title}">
                        <span v-if="title.indexOf(searchAreaValue) > -1">
                          {{title.substr(0, title.indexOf(searchAreaValue))}}
                        <span style="color: #32CD32">{{searchAreaValue}}</span>
                          {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                        </span>
                        <span v-else>{{title}}</span>
                      </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
    </a-card>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed"></a-icon>
  <a-card :bordered="false" class="new-table-card">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('发送方式')">
               <a-select
                      v-model="queryParam.sendWay"
                      style="width: 100%"
                      :placeholder="$t('请选择发送方式')"
                    >
                      <a-select-option v-for="(item,key) in messageSendWayObj" :value="key" :key="key">
                        {{ $t(item) }}
                      </a-select-option>
                    </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('发送状态')">
               <a-select
                      v-model="queryParam.successFlag"
                      style="width: 100%"
                      :placeholder="$t('请选择成功标志')"
                    >
                      <a-select-option v-for="(item,key) in messageSuccFlagObj" :value="key" :key="key">
                        {{ $t(item) }}
                      </a-select-option>
                    </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编号')">
              <a-input :placeholder="$t('请输入用户编号进行查询')" v-model="queryParam.userId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户名称')">
              <a-input :placeholder="$t('请输入用户名称进行查询')" v-model="queryParam.userName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <a-input :placeholder="$t('请输入表编号进行查询')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('meter_message_record')">{{ $t('导出') }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <!--<a @click="handleDetail(record)">详情</a>-->
        </span>

      </a-table>
    </div>

    <meter-message-record-modal ref="modalForm" @ok="modalFormOk"></meter-message-record-modal>
      </a-card>
  </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterMessageRecordModal from './modules/MeterMessageRecordModal'
  import {messageSendFlagObj,messageSuccFlagObj,messageSendWayObj} from '@/utils/constants/commonConstant'
  import {isUndefined} from '@/utils/validate'

  export default {
    name: 'MeterMessageRecordList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
      MeterMessageRecordModal
    },
    data () {
      return {
        description: this.$t('meter_message_record管理页面'),
        messageSuccFlagObj,
        messageSendWayObj,
        url: {
          list: "/jeecg-charge/meter/meterMessageRecord/list",
          delete: "/jeecg-charge/meter/meterMessageRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meterMessageRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterMessageRecord/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterMessageRecord/importExcel",
          
        },
        dictOptions:{},
        
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName'
          },
          {
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
            width:200,
            ellipsis: true,
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId'
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },
          {
            title: this.$t('告警类型'),
            align:"center",
            dataIndex: 'messageFlag',
            customRender: (t,r,index) => {
                if(!isUndefined(messageSendFlagObj[t])) {
                    return this.$t(messageSendFlagObj[t])
                }
              return this.$t('未知');
            }
          },
          /*
          {
            title:'发送信息内容',
            align:"center",
            dataIndex: 'message'
          },
          */
          {
            title: this.$t('发送方式'),
            align:"center",
            dataIndex: 'sendWay',
            customRender: (t,r,index) => {
                if(!isUndefined(messageSendWayObj[t])) {
                    return this.$t(messageSendWayObj[t])
                }
              return this.$t('未知');
            }
          },
          {
            title: this.$t('发送的电话号码'),
            align:"center",
            dataIndex: 'phone'
          },
          {
            title: this.$t('发送状态'),
            align:"center",
            dataIndex: 'successFlag',
            customRender: (t,r,index) => {
              let obj =messageSuccFlagObj
                if(!isUndefined(obj[t])) {
                    return this.$t(obj[t])
                }
              return this.$t('未知');
            }
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          /*
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
          */
        ]
      },
    },
    methods: {
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>